import React from 'react'
import t from '~t'

import { Preloader, ButtonsGroup, Button } from '~ui';

export default function BookmarkEditFormActionMain({ status, onRemove }) {
    switch(status){
        case 'saving':
        case 'loading':
            return (
                <Button variant='ghost'>
                    <Preloader />
                </Button>
            )

        case 'loaded':
            return (
                <ButtonsGroup>
                    <Button 
                        variant='flat'
                        accent='danger'
                        onClick={onRemove}>
                        {t.s('remove')}
                    </Button>
                </ButtonsGroup>
            )

        case 'removed':
            return (
                <Button 
                    variant='accent'
                    accent='danger'
                    onClick={onRemove}>
                    {t.s('removeFromTrash')}
                </Button>
            )

        case 'idle':
            return null

        default: //new|error|errorSaving
            return (
                <Button
                    as='input'
                    type='submit'
                    variant='primary'
                    value={t.s('save')} />
            )
    }
}